import { render, staticRenderFns } from "./ModalReviewTicket.vue?vue&type=template&id=762c3832"
import script from "./ModalReviewTicket.vue?vue&type=script&lang=js"
export * from "./ModalReviewTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports